import { createStore } from 'vuex'
import { ElMessage } from 'element-plus'
import axios from '../../config-axios'

import company from '@/store/modules/company'
import compressor from '@/store/modules/compressor'
import user from '@/store/modules/user'
import modem from '@/store/modules/modem'
import notification from '@/store/modules/notification'
import table from '@/store/modules/table'

export default createStore({
  modules: {
    company,
    compressor,
    user,
    modem,
    notification,
    table
  },
  state: {
  },
  getters: {
    
  },
  mutations: {
  },
  actions: {
  },
})
